export * from './offer.interface';
